import { useEffect } from 'react';

export const BASE_URL = 'https://www.optionstrackerapp.com';
const DEFAULT_OG_IMAGE = `${BASE_URL}/og-image.png`;

/**
 * SEO component for managing page-specific meta tags
 * Updates document title, meta description, canonical URL, keywords, and OG image on mount
 */
function SEO({ title, description, canonicalPath, ogImage, keywords }) {
  useEffect(() => {
    // Update document title
    const fullTitle = title
      ? `${title} | Options Tracker`
      : 'Options Tracker - Track Your Options Wheel Strategy & LEAPS Trades';
    document.title = fullTitle;

    // Update meta keywords
    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords);
      }
    }

    // Update meta description
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      }

      // Update Open Graph description
      let ogDescription = document.querySelector('meta[property="og:description"]');
      if (ogDescription) {
        ogDescription.setAttribute('content', description);
      }

      // Update Twitter description
      let twitterDescription = document.querySelector('meta[name="twitter:description"]');
      if (twitterDescription) {
        twitterDescription.setAttribute('content', description);
      }
    }

    // Update Open Graph title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', fullTitle);
    }

    // Update Twitter title
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', fullTitle);
    }

    // Update canonical URL
    if (canonicalPath !== undefined) {
      const canonicalUrl = canonicalPath ? `${BASE_URL}${canonicalPath}` : BASE_URL;
      let canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        canonical.setAttribute('href', canonicalUrl);
      }

      // Update OG URL
      let ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) {
        ogUrl.setAttribute('content', canonicalUrl);
      }

      // Update Twitter URL
      let twitterUrl = document.querySelector('meta[name="twitter:url"]');
      if (twitterUrl) {
        twitterUrl.setAttribute('content', canonicalUrl);
      }
    }

    // Update OG image
    const imageUrl = ogImage ? `${BASE_URL}${ogImage}` : DEFAULT_OG_IMAGE;
    let ogImageMeta = document.querySelector('meta[property="og:image"]');
    if (ogImageMeta) {
      ogImageMeta.setAttribute('content', imageUrl);
    }

    // Update Twitter image
    let twitterImage = document.querySelector('meta[name="twitter:image"]');
    if (twitterImage) {
      twitterImage.setAttribute('content', imageUrl);
    }

    // Cleanup: reset to defaults on unmount
    return () => {
      document.title = 'Options Tracker - Track Your Options Wheel Strategy & LEAPS Trades';

      // Reset canonical URL
      let canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        canonical.setAttribute('href', BASE_URL);
      }

      // Reset OG image to default
      let ogImageMeta = document.querySelector('meta[property="og:image"]');
      if (ogImageMeta) {
        ogImageMeta.setAttribute('content', DEFAULT_OG_IMAGE);
      }

      let twitterImage = document.querySelector('meta[name="twitter:image"]');
      if (twitterImage) {
        twitterImage.setAttribute('content', DEFAULT_OG_IMAGE);
      }
    };
  }, [title, description, canonicalPath, ogImage, keywords]);

  return null;
}

export default SEO;
